export default {
  namespaced: true,
  stream_type: {
    title: "Tipo de stream",
    master_account_title: "Tipo de stream por defecto",
    select_placeholder: "Selecciona los tipos de stream",
    inherited_from_master_account: "Se usarán los de la cuenta maestra",
    none_configured: "Sin tipos configurados, se regresarán todos los disponibles",
    order_help:
      "El orden de la lista es el orden en el que se regresan los streams.",
  },
};
